export default __webpack_public_path__ + "static/logo-12045a1b33e535c26f5642f4ce784421.png";